var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReverse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 5.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 5.5,
    stroke: "#346C75"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.86 17.5266L16 20.3933L13.14 17.5266C13.0145 17.4011 12.8442 17.3306 12.6667 17.3306C12.4892 17.3306 12.3189 17.4011 12.1934 17.5266C12.0678 17.6522 11.9973 17.8224 11.9973 18C11.9973 18.1775 12.0678 18.3478 12.1934 18.4733L15.5267 21.8066C15.5887 21.8691 15.6624 21.9187 15.7437 21.9526C15.8249 21.9864 15.912 22.0038 16 22.0038C16.088 22.0038 16.1752 21.9864 16.2564 21.9526C16.3377 21.9187 16.4114 21.8691 16.4734 21.8066L19.8067 18.4733C19.8689 18.4111 19.9182 18.3373 19.9518 18.2561C19.9855 18.1749 20.0028 18.0879 20.0028 18C20.0028 17.9121 19.9855 17.825 19.9518 17.7438C19.9182 17.6626 19.8689 17.5888 19.8067 17.5266C19.7445 17.4645 19.6708 17.4152 19.5895 17.3815C19.5083 17.3479 19.4213 17.3306 19.3334 17.3306C19.2455 17.3306 19.1584 17.3479 19.0772 17.3815C18.996 17.4152 18.9222 17.4645 18.86 17.5266V17.5266ZM13.14 14.4733L16 11.6066L18.86 14.4733C18.922 14.5358 18.9958 14.5854 19.077 14.6192C19.1582 14.6531 19.2454 14.6705 19.3334 14.6705C19.4214 14.6705 19.5085 14.6531 19.5898 14.6192C19.671 14.5854 19.7447 14.5358 19.8067 14.4733C19.8692 14.4113 19.9188 14.3376 19.9526 14.2563C19.9865 14.1751 20.0039 14.088 20.0039 14C20.0039 13.912 19.9865 13.8248 19.9526 13.7436C19.9188 13.6623 19.8692 13.5886 19.8067 13.5266L16.4734 10.1933C16.4114 10.1308 16.3377 10.0812 16.2564 10.0474C16.1752 10.0135 16.088 9.99609 16 9.99609C15.912 9.99609 15.8249 10.0135 15.7437 10.0474C15.6624 10.0812 15.5887 10.1308 15.5267 10.1933L12.1934 13.5266C12.0678 13.6522 11.9973 13.8224 11.9973 14C11.9973 14.1775 12.0678 14.3478 12.1934 14.4733C12.3189 14.5988 12.4892 14.6694 12.6667 14.6694C12.8442 14.6694 13.0145 14.5988 13.14 14.4733Z",
    fill: "#346C75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReverse);
export default __webpack_public_path__ + "static/media/reverse.8c855d15e7326f11621dcd4ebfc9d027.svg";
export { ForwardRef as ReactComponent };